/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../../core";
import { SpacePattern } from "./SpacePattern";
export const SpacePatternResponse = core.serialization.object({
    data: SpacePattern,
});
